export default __webpack_public_path__ + "static/media/cryptofont-webfont.1d3116f3.woff";